import { db } from "@/firebaseConfig";

const settingsCollection = db.collection("settings");

const saveSetting = async (id, data) => {
  settingsCollection
    .doc(id)
    .set(data)
    .then(() => {
      console.log("Setting successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateSetting = async (id, data) => {
  settingsCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("Setting successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteSetting = async id => {
  settingsCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("Setting successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getSettingById = async id => {
  return settingsCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

export {
  settingsCollection,
  saveSetting,
  updateSetting,
  deleteSetting,
  getSettingById
};
